import {Routes,Route} from "react-router-dom"
import Footer from "./components/footer/Footer";
// import Message from "./components/message/Message";
import Navber from "./components/navber/Navber";
import ForgetPassword from "./pages/ForgetPassword";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import Permanent from "./pages/Permanent";
import ProfilePage from "./pages/ProfilePage";
import RegesterPage from "./pages/RegesterPage";
import EmailRegesterPage from "./pages/EmailRegesterPage"
import Add from "./components/navber/Add";
import { useEffect, useState } from "react";



function App() {


  const [state, setstate] = useState(true)


  useEffect(()=>{
    const script = document.createElement('script');
    script.src = "https://speeddial-uhuu.s3.amazonaws.com/f276db5d-dc8c-459e-8e3a-51e539e5ca9e/dc2a4fb4-39ae-4c0c-b01b-71ceeb7acb51/speeddial/static/js/main.js";
    script.async = true;

    document.body.appendChild(script);

    return () =>{
      document.body.removeChild(script)
    }
  },[])

  return (
    <div className="app">
        {
          state && (
            <div className="lg:hidden h-[75px]">
              <Add setstate={setstate}/>
          </div>
          )
        }
        <Navber/>
        <Routes>
            <Route path="/" element={<HomePage/>} />
            <Route path="/login" element={<LoginPage/>} />
            <Route path="/signup" element={<RegesterPage/>} />
            <Route path="/signup-email" element={<EmailRegesterPage/>} />
            <Route path="/forget-password" element={<ForgetPassword/>} />
            <Route path="/profile" element={<ProfilePage/>} />
            <Route path="/permanent" element={<Permanent/>} />
        </Routes>
        {/* <Message/> */}
         <div id="sdroot"></div>
        <Footer/>
    </div>
  );
}

export default App;
